export const celularInsertMask = (celular: string): string => {
    celular = celular.replace(/\D/g, '') // Remove tudo o que não é dígito
    celular = celular.replace(/^(\d{2})(\d)/g, '($1) $2') // Coloca parênteses em volta dos dois primeiros dígitos
    celular = celular.replace(/(\d)(\d{4})$/, '$1-$2') // Coloca hífen entre o quarto e o quinto dígitos
    return celular
}

export const celularRemoveMask = (celular: string): string => {
    return celular.replace(/\D/g, '')
}